import React, { useState } from 'react';

const ContactMe = () => {
  const [hideOtherSections, setHideOtherSections] = useState(false);

  const handleLinkClick = () => {
    setHideOtherSections(true);
  };

  const redirectToEmail = () => {
    window.location.href = 'mailto:calmus885@example.com';
  };

  return (
    <section
      data-aos='fade-left'
      data-aos-duration='1000'
      id='contact'
      className={`py-8 pt-10 ${hideOtherSections ? 'hide-sections' : ''}`}
    >
      <div className="container mx-auto px-4">
        <h2 className="text-[2rem] font-[800] text-center text-white mb-4 ">Get in touch</h2>
        <p className="lg:max-[600px] text-center pb-4 justify-center lg:max-auto text-smallTextColor font-semibold text-[16px] leading-7">
          Open for new opportunities to collaborate with diverse teams and create cutting-edge software solutions, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!
        </p>
        <div className="flex justify-center">
          <button
            className="text-white border border-solid border-white py-2 px-4 rounded-none max-h-[35px] flex items-center hover:bg-primaryColor ease-in duration-300 gap-2"
            onClick={redirectToEmail}
          >
            <i className="ri-emoji-sticker-line"></i> Say Hello
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactMe;